import React, { Component } from 'react';
import CountUp from 'react-countup';

import './index.scss';

import Advantages from './components/Advantages'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Intro from '../../components/Intro'
import Warning from '../../components/Warning'
// import Logos from '../../components/Logos'
import Container from '../../components/Container'
import Depositions from './components/Depositions'

// import amil from '../../assets/logos/amil.svg'
// import raizen from '../../assets/logos/raizen.svg'
// import bs2 from '../../assets/logos/bs2.svg'
// import nextel from '../../assets/logos/nextel.svg'

class Company extends Component {
  state = {
    visibility: false
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const currentScrollPos = window.pageYOffset + (window.innerHeight * 0.9);
    const { metrics } = this
    const { visibility } = this.state
    let newVisibility = false

    if (currentScrollPos >= metrics.offsetTop) {
      newVisibility = true
    }

    if (visibility !== newVisibility) {
      this.setState({ visibility: newVisibility })
    }
  }

  render() {
    const { visibility } = this.state
    return (
      <div className="company">
        <Warning
          title=""
          area="Atendimento"
          phone="(21) 2391-1015"
        />
        <Header
          options={[
            { text: 'Vantagens', to: 'Advantages', reactScroll: true },
            { text: 'Depoimentos', to: 'Depositions', reactScroll: true },
            { text: 'Sou um advogado', to: '/' }
          ]}
        />
        <Intro
          type="company"
          title="Gerencie e resolva o seu contencioso de forma eficiente."
          to="Advantages"
        />
        {/*<Logos
          items={[
            { image: amil },
            { image: raizen },
            { image: bs2 },
            { image: nextel }
          ]}
        />*/}
        <Advantages />
        <div className="metrics">
          <div className="metrics__background">
            <span />
            <span />
          </div>
          <Container>
            <div className="metrics__wrapper" ref={el => this.metrics = el}>
              <div className="metrics__square">
                {visibility &&
                  <div>
                    <CountUp
                      className='counter'
                      start={0}
                      end={350}
                      decimals={0}
                      duration={3}
                      delay={1}
                      suffix="+"
                    />
                    <h1>Escritórios</h1>
                  </div>
                }
              </div>
              <div className="metrics__square">
                {visibility &&
                  <div>
                    <CountUp
                      className='counter'
                      start={0}
                      end={150}
                      decimals={0}
                      duration={3}
                      delay={1}
                      suffix="+"
                    />
                    <h1>Empresas</h1>
                  </div>
                }
              </div>
            </div>
          </Container>
        </div>
        <Depositions />
        <Footer
          type="company"
          options={[
            { text: 'Vantagens', to: 'Advantages', reactScroll: true },
            { text: 'Depoimentos', to: 'Depositions', reactScroll: true },
            { text: 'Sou um Advogado', to: '/' },
            { text: 'Termos de Uso', to: '/termos-de-uso' }
          ]}
        />
      </div>
    )
  }
}

export default Company
